export const SUPPORTED_LANGUAGES = ["es"];

export const DEFAULT_LANGUAGE = "es";
